class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
    var mountHere = document.querySelector('#gorgias-chat-container')
    if(mountHere){
      event.target.closest('details').hasAttribute('open')? mountHere.style.display = 'none' : mountHere.style.display = 'block'
    }
    const searchIcon = document.querySelector('.header-icon-search')
    const closeIcon = document.querySelector('.header-icon-close')
    const announcement_bar = document.querySelector('.shopify-section-announcement-bar')
    if (event.target.closest('details').hasAttribute('open')) {
      if (searchIcon) {
        searchIcon.style.display = 'none'
        closeIcon.style.display = 'block'
      }
      if (announcement_bar && window.innerWidth < 768) {
        announcement_bar.style.display = 'none'
      }
      // init search swiper
      if (window.innerWidth > 768) {
        const swiper = new Swiper('.search-product-card-list.swiper', {
          slidesPerView: 5,
          spaceBetween: 8,
          loop: false,
          navigation: {
            nextEl: '.swiper_icon_right',
            prevEl: '.swiper_icon_left',
          },
          observer: true,
          observeParents: true,
          on: {
            init: function () {
              var left = document.querySelectorAll('.swiper_icon_left')
              left.forEach(i => {
                i.classList.add('swiper-button-disabled')
              }) 
            },
            transitionEnd: function () {
              return
            },
            resize: function () {
              return
            }
          }
        });
      }
    } else {
      if (closeIcon) {
        closeIcon.style.display = 'none'
        searchIcon.style.display = 'block'
      }
      if (announcement_bar && window.innerWidth < 768) {
        announcement_bar.style.display = 'block'
      }
    }
  }

  onBodyClick(event) {
    if (event.target.closest('[data-action="close-search"]') !== null) {
      const announcement_bar = document.querySelector('.shopify-section-announcement-bar')
      if (announcement_bar && window.innerWidth < 768) {
        announcement_bar.style.display = 'block'
      }
      var mountHere = document.querySelector('#gorgias-chat-container')
      if(mountHere){
        mountHere.style.display = 'block'
      }
      this.close(false);
    }
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      // this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    const modal__toggle = document.querySelectorAll('.modal__toggle-close')
    const modal__toggle_open = document.querySelectorAll('.modal__toggle-open')
    if(modal__toggle.length > 0){
      modal__toggle.forEach(i => i.style.display = 'none')
      modal__toggle_open.forEach(i => i.style.display = 'block')
    }
  }
}

customElements.define('details-modal', DetailsModal);
